@if (showEmptyInViewMode() || items.length || editMode) {
  <div class="relative" [class.h-full]="fillHeight()">
    <div
      #viewport
      tabindex="-1"
      class="flex gap-2 overflow-x-auto scroll-smooth outline-none [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      [style.height]="fillHeight() ? '100%' : itemHeight + 'px'"
      (scroll)="onViewportScroll()"
    >
      @if (canShowEmptyView && emptyMode() === 'add') {
        <button
          z-button
          type="button"
          zType="outline"
          class="flex shrink-0 flex-col items-center justify-center gap-2 rounded-xl border-dashed border-muted-foreground/40 px-6"
          [style.width.px]="resolveItemWidth()"
          (click)="emitAddItem()"
        >
          <ng-icon name="lucideImagePlus" class="icon-size-5"></ng-icon>
          <span>Add media</span>
        </button>
      } @else if (canShowEmptyView && emptyMode() === 'static') {
        <div
          class="w-full shrink-0"
          [style.background-color]="emptyBackgroundColor()"
        >
          @if (emptyImageUrl()) {
            <img
              class="h-full w-full object-fill"
              [src]="emptyImageUrl()"
              alt=""
            />
          }
        </div>
      }

      @for (item of items; track trackItem($index, item)) {
        <article
          [class]="itemArticleClasses"
          [class.ring-2]="current === item"
          [class.ring-primary]="current === item"
          [class.w-full]="!renderModeIsList"
          [style.width.px]="resolveItemWidth()"
          (click)="onItemClick(item)"
        >
          @if (item.type === 'video') {
            <video
              [class]="videoClasses"
              [style.object-fit]="fitContent()"
              [src]="item.base64Url || item.url"
              [controls]="videoControls()"
              [attr.data-current]="current === item ? 'true' : null"
              (play)="handleVideoPlay($event)"
              (pause)="handleVideoPause()"
              (ended)="handleVideoEnd()"
            ></video>
          } @else {
            <img
              [class]="imageClasses"
              [style.object-fit]="fitContent()"
              [src]="item.base64Url || item.url"
              [alt]="item.name || 'carousel item'"
            />
          }

          @if (item.name && showItemCaption()) {
            <div class="absolute inset-x-0 bottom-0 truncate bg-black/60 px-3 py-2 text-sm text-white">
              {{ item.name }}
            </div>
          }

          @if (editMode) {
            <button
              z-button
              type="button"
              zType="destructive"
              class="absolute right-2 top-2 opacity-0 transition-opacity group-hover:opacity-100"
              (click)="emitDeleteItem(item, $event)"
            >
              <ng-icon name="lucideTrash2" class="icon-size-4"></ng-icon>
            </button>
          }
        </article>
      }
    </div>

    @if (renderModeIsList ? viewportRemainingToStart > 0 : currentIndex > 0 || (currentIndex === 0 && canShowEmptyView)) {
      <button
        type="button"
        aria-label="Previous"
        [class]="navButtonClasses('left-2')"
        [style.background-color]="'rgba(17, 24, 39, 0.45)'"
        (click)="goToPrevious($event)"
      >
        <ng-icon name="lucideChevronLeft" class="icon-size-4"></ng-icon>
      </button>
    }

    @if (renderModeIsList ? viewportRemainingToEnd > 0 : (!current && items.length > 1) || (current && currentIndex < items.length - 1)) {
      <button
        type="button"
        aria-label="Next"
        [class]="navButtonClasses('right-2')"
        [style.background-color]="'rgba(17, 24, 39, 0.45)'"
        (click)="goToNext($event)"
      >
        <ng-icon name="lucideChevronRight" class="icon-size-4"></ng-icon>
      </button>
    }

    @if (showDots) {
      <span
        class="pointer-events-none absolute inset-x-0 flex items-center justify-center gap-[5px]"
        [style.bottom.px]="dotsBottomPx()"
      >
        @for (item of items; track trackItem($index, item)) {
          <i [class]="$index === activeDotIndex ? activeDotClass() : inactiveDotClass()"></i>
        }
      </span>
    }
  </div>
}
